import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="public-username" on the shared <dialog>. Opened by the
// bookmark-visibility controller (via a public-username:required event) the first time a user makes
// a bookmark public without a public handle yet: it claims the handle, then calls the retry
// callback so the original toggle re-runs and the bookmark actually goes public.
export default class extends Controller {
    static targets = ["input", "error", "preview"]

    connect() {
        this.onRequired = this.onRequired.bind(this)
        document.addEventListener("public-username:required", this.onRequired)
    }

    disconnect() {
        document.removeEventListener("public-username:required", this.onRequired)
    }

    onRequired(e) {
        this.onClaimed = e.detail.onClaimed
        this.inputTarget.value = e.detail.suggested || ""
        this.hideError()
        this.updatePreview()
        this.element.showModal()
    }

    updatePreview() {
        if (this.hasPreviewTarget) this.previewTarget.textContent = this.inputTarget.value || "yourname"
    }

    hideError() {
        this.errorTarget.textContent = ""
        this.errorTarget.classList.add("hidden")
    }

    cancel() {
        this.element.close()
    }

    save(e) {
        e.preventDefault()
        const csrfToken = document.querySelector("[name='csrf-token']").content

        fetch("/settings/public_username", {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({ username: this.inputTarget.value.trim() })
        }).then(response => response.json().then(data => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            if (ok && data.ok) {
                this.element.close()
                if (this.onClaimed) this.onClaimed()
            } else {
                this.errorTarget.textContent = data.error || "Couldn't save that username."
                this.errorTarget.classList.remove("hidden")
            }
        }).catch(() => {
            this.errorTarget.textContent = "Something went wrong. Please try again."
            this.errorTarget.classList.remove("hidden")
        })
    }
}
